export function swapDynamicText(str: string, keys: Record<string, string>) {
    for (const [k, v] of Object.entries(keys)) {
        const t = `{{ ${k} }}`;

        // If the string doesn't contain the key,
        // return an empty string so we don't show janky UI.
        if (!str.includes(t)) {
            return '';
        }

        str = str.replace(t, v);
    }

    return str;
}

// Splits a string in half by whole word.
export function splitTextInTwo(text = '') {
    let middle = Math.floor(text.length / 2);

    const before = text.lastIndexOf(' ', middle);
    const after = text.indexOf(' ', middle + 1);

    if (before === -1 || (after !== -1 && middle - before >= after - middle)) {
        middle = after;
    } else {
        middle = before;
    }

    const s1 = text.slice(0, middle);
    const s2 = text.slice(middle + 1);

    return { s1, s2 };
}
